import { render } from "./PayrollForm.vue?vue&type=template&id=0c3d3759&scoped=true&ts=true"
import script from "./PayrollForm.vue?vue&type=script&lang=ts"
export * from "./PayrollForm.vue?vue&type=script&lang=ts"

import "./PayrollForm.vue?vue&type=style&index=0&id=0c3d3759&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3d3759"]])

export default __exports__